import { render, staticRenderFns } from "./OrderSummary.vue?vue&type=template&id=ea5fcec2&scoped=true&"
import script from "./OrderSummary.vue?vue&type=script&lang=ts&"
export * from "./OrderSummary.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea5fcec2",
  null
  
)

export default component.exports